import { render, staticRenderFns } from "./CategoryStep.vue?vue&type=template&id=4d17e8fa"
import script from "./CategoryStep.vue?vue&type=script&lang=js"
export * from "./CategoryStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default})
